import type { CSSProperties } from 'react'
import { adressesDe, type Destinataire, teinteDe } from '../adresses'
import { provenancePiece } from '../libelles'

// Une adresse mail en puce, colorée d'après l'adresse elle-même : la même boîte garde
// la même couleur partout, ce qui montre d'un coup d'œil à qui un mail a été adressé.

export function PuceAdresse({ nom, adresse }: Destinataire) {
  if (!adresse) return <span className="badge puce-adresse">{nom}</span>
  return (
    <span
      className="badge puce-adresse"
      style={{ '--teinte': teinteDe(adresse) } as CSSProperties}
      title={nom ? `${nom} <${adresse}>` : adresse}
    >
      {adresse}
    </span>
  )
}

/** Provenance d'une pièce : la boîte d'arrivée en puce quand elle est connue, sinon la source. */
export function ProvenancePiece({ p }: { p: { source: string; boite: string | null } }) {
  return p.source === 'gmail' && p.boite ? (
    <PuceAdresse nom={null} adresse={p.boite} />
  ) : (
    <>{provenancePiece(p)}</>
  )
}

/** Les destinataires d'un en-tête (À, Cc), une puce chacun. */
export function PucesAdresses({ entete }: { entete: string }) {
  return (
    <>
      {adressesDe(entete).map((d, i) => (
        <PuceAdresse key={`${d.adresse ?? d.nom}-${i}`} {...d} />
      ))}
    </>
  )
}
